export default "__VITE_ASSET__Bsn7jqxN__"